import {
	LOGIN_SUCCESS,
	LOGOUT,
	USER_SUCCESS,
	SET_LANGUAGE,
	SET_CURRENT_SEASON,
	SET_SELECTED_MENU_ITEM,
	SET_PLAYER_TAB,
	SET_TEAM_TAB,
	SET_MATCH_TAB,
	SET_TRAINING_TAB,
} from "@/actions";

const initialState = {
	isLoggedIn: false,
	token: null,
	user: null,
	language: "it",
	selectedMenuItem: "",
	playerTab: "main_info",
	teamTab: "main_info",
	matchTab: "main_info",
	trainingTab: "main_info",
};

const authReducer = (state = initialState, action) => {
	switch (action.type) {
		case LOGIN_SUCCESS:
			return {
				...state,
				isLoggedIn: true,
				token: action.payload,
			};
		case LOGOUT:
			return {
				...state,
				isLoggedIn: false,
				token: null,
				user: null,
			};
		case USER_SUCCESS:
			return {
				...state,
				user: action.payload?.user,
				season: action.payload?.season,
				seasons: action.payload?.seasons,
			};
		case SET_CURRENT_SEASON:
			return {
				...state,
				season: action.payload?.season,
			};
		case SET_LANGUAGE:
			return {
				...state,
				language: action.payload,
			};
		case SET_SELECTED_MENU_ITEM:
			return {
				...state,
				selectedMenuItem: action.payload,
			};
		case SET_PLAYER_TAB:
			return {
				...state,
				playerTab: action.payload,
			};
		case SET_TEAM_TAB:
			return {
				...state,
				teamTab: action.payload,
			};
		case SET_MATCH_TAB:
			return {
				...state,
				matchTab: action.payload,
			};
		case SET_TRAINING_TAB:
			return {
				...state,
				trainingTab: action.payload,
			};
		default:
			return state;
	}
};

export default authReducer;
